import api from './index'
import type { V1ApiResponse } from '@/types'

export const WALLET_TYPE_COIN = 1
export const WALLET_TYPE_GROWTH = 2

export const ACCOUNT_TYPE_PURCHASE = 1
export const ACCOUNT_TYPE_VIP = 2
export const ACCOUNT_TYPE_GIFT = 3
export const ACCOUNT_TYPE_ACTIVITY = 6

export const CHANGE_DIRECTION_INCOME = 1
export const CHANGE_DIRECTION_EXPENSE = 2

export interface UserWalletTypeSummary {
  walletType: number
  walletTypeName: string
  totalAmount: string
  balanceAmount: string
  frozenAmount: string
  pendingIncomeAmount: string
  pendingExpenseAmount: string
  pendingSettlementAmount: string
  accumulatedIncomeAmount: string
  accumulatedExpenseAmount: string
}

export interface UserWalletAccount {
  userWalletAccountId: number | null
  walletCategoryId: number
  walletCategoryCode: string
  walletCategoryName: string
  walletIcon: string
  walletType: number
  walletTypeName: string
  accountType: number
  accountTypeName: string
  totalAmount: string
  balanceAmount: string
  frozenAmount: string
  pendingIncomeAmount: string
  pendingExpenseAmount: string
  pendingSettlementAmount: string
  accumulatedIncomeAmount: string
  accumulatedExpenseAmount: string
  allowWithdraw: number
  accountEnabled: number
}

export interface UserWalletAccountsData {
  walletTypeSummaries: UserWalletTypeSummary[]
  accounts: UserWalletAccount[]
}

export interface UserWalletFlowLogQuery {
  pageNo?: number
  pageSize?: number
  walletCategoryCode?: string
  walletType?: number
  accountType?: number
  changeDirection?: number
  flowStatus?: number
  changeType?: string
  sourceBizType?: string
  bizOrderNo?: string
  startTime?: string
  endTime?: string
}

export interface UserWalletFlowLogItem {
  walletFlowLogId: number
  walletCategoryCode: string
  walletCategoryName: string
  walletIcon?: string
  walletType: number
  walletTypeName: string
  accountType: number
  accountTypeName: string
  bizOrderNo: string
  sourceBizType: string
  changeType: string
  changeTypeName: string
  changeDirection: number
  changeDirectionName: string
  flowStatus: number
  flowStatusName: string
  amountEffectType: string
  changeAmount: string
  displayAmount: string
  beforeBalanceAmount: string
  afterBalanceAmount: string
  beforeTotalAmount: string
  afterTotalAmount: string
  changeRemark: string | null
  successDateTime: string | null
  createDateTime: string
}

export interface UserWalletFlowLogsData {
  list: UserWalletFlowLogItem[]
  total: number
  pageNo: number
  pageSize: number
}

export const walletApi = {
  /** 查询当前用户钱包余额，无需传递查询参数 */
  queryAccounts: (): Promise<V1ApiResponse<UserWalletAccountsData>> =>
    api.get('/v1/users/me/wallet/accounts'),

  /** 分页查询当前用户钱包流水 */
  queryFlowLogs: (
    params: UserWalletFlowLogQuery
  ): Promise<V1ApiResponse<UserWalletFlowLogsData>> =>
    api.get('/v1/users/me/wallet/flow-logs', { params }),
}

export default walletApi
